class InputShowHidePwd extends HTMLElement {
  constructor() {
    super();
    this.targetInput = null;
    this.state = true; // Default hidden pwd
    this.buttonEl = null;
  }

  showPwd(state) {
    const elOpen = this.querySelector('.open');
    const elClose = this.querySelector('.close');

    if (state) {
      elClose.style.display = 'none';
      elOpen.style.display = 'block';
    } else {
      elClose.style.display = 'block';
      elOpen.style.display = 'none';
    }

    // Input
    if (this.targetInput) {
      this.targetInput.setAttribute('type', (state ? 'password' : 'text'));
    }
  }

  buttonHandler() {
    this.state = !this.state;
    this.showPwd(this.state);
  }

  render() {
    this.targetInput = document.querySelector(`#${this.getAttribute('input-id')}`)
    this.buttonEl = document.createElement('button');
    this.buttonEl.setAttribute('type', 'button');
    this.buttonEl.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path class="open" d="M12,4.01c4.79,0,8.77,3.44,9.61,7.99c-0.84,4.55-4.82,7.99-9.61,7.99c-4.79,0-8.77-3.44-9.61-7.99 C3.23,7.45,7.21,4.01,12,4.01z M12,18.22c3.76,0,6.98-2.62,7.79-6.22C18.98,8.4,15.76,5.78,12,5.78C8.24,5.78,5.02,8.4,4.21,12 C5.02,15.6,8.24,18.22,12,18.22z M12,16c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4C16,14.21,14.21,16,12,16z M12,14.22c1.23,0,2.22-0.99,2.22-2.22S13.23,9.78,12,9.78S9.78,10.77,9.78,12S10.77,14.22,12,14.22z"/>
        <path class="close opacity-30" d="M12,4.01c4.79,0,8.77,3.44,9.61,7.99c-0.84,4.55-4.82,7.99-9.61,7.99c-4.79,0-8.77-3.44-9.61-7.99 C3.23,7.45,7.21,4.01,12,4.01z M12,18.22c3.76,0,6.98-2.62,7.79-6.22C18.98,8.4,15.76,5.78,12,5.78C8.24,5.78,5.02,8.4,4.21,12 C5.02,15.6,8.24,18.22,12,18.22z"/>
      </svg>
    `;

    this.append(this.buttonEl);
    this.showPwd(this.state);
    this.buttonEl.addEventListener('click', this.buttonHandler.bind(this));
  }

  connectedCallback() {
    this.render();
  }

  disconnectedCallback() {
    this.buttonEl.removeEventListener('click', this.buttonHandler.bind(this));
  }
}

class LanguageSelector extends HTMLElement {
  constructor() {
    super();
  }

  selectChangeHandler(evt) {
    this.formEl.submit();
  }

  init() {
    this.formEl = this.querySelector('form');
    this.selectEl = this.querySelector('select');

    if (this.formEl && this.selectEl) {
      this.selectEl.addEventListener('change', this.selectChangeHandler.bind(this));
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    });
  }

  disconnectedCallback() {
    this.selectEl.removeEventListener('change', this.selectChangeHandler.bind(this));
  }
}

class AlpVatValidation extends HTMLElement {
  constructor() {
    super();
    this.vatEmailInput = null;
    this.vatNumberInput = null;
    this.erroContainerEl = null;
    this.formEl = null;
    this.forActionUrl = null;
    this.validateButtonEl = null;

    this.MESSAGE_TYPES = {
      NO_EMAIL: 'no-email',
      NO_VAT: 'no-vat',
      WRONG_EMAIL: 'wrong-email',
    }
  }

  showError(errorType) {
    const {
      messageNoEmail,
      messageNoVatNumber,
      messageWrongEmail,
    } = this.dataset;

    if (this.erroContainerEl) {
      let message = '';
      if (errorType === this.MESSAGE_TYPES.NO_EMAIL) message = messageNoEmail || '';
      if (errorType === this.MESSAGE_TYPES.WRONG_EMAIL) message = messageWrongEmail || '';
      if (errorType === this.MESSAGE_TYPES.NO_VAT) message = messageNoVatNumber || '';

      console.log('errorType: ', errorType, ', --> ', this.dataset);
      this.erroContainerEl.innerHTML = message;
      this.erroContainerEl.classList.toggle('hidden', false);
    }
  }

  validateVat(email, vatNumber) {
    const endPoint = `/apps/sufio/customer-vat/?email=${email}&vat_no=${vatNumber}&update=true`;

    this.setButtonValidationState(true);
    fetch(endPoint).catch(() => {
      console.warn('Soumission numéro de TVA sur Sufio echoué');
    }).finally(() => {
      this.gotoCheckout();
      this.setButtonValidationState();
    })
  }

  setButtonValidationState(state = false) {
    this.validateButtonEl && this.validateButtonEl.setAttribute('disabled', state);
  }

  gotoCheckout(isBySubmitButton) {
    console.log('this.formEl --> ', this.formEl);
    if (isBySubmitButton) {
      const submitButtonEl = this.querySelector('.default-form-subit-button');

      submitButtonEl && submitButtonEl.click();
    } else {
      this.formEl && this.formEl.submit();
    }
  }

  validateVATForm() {
    if (this.vatEmailInput && this.vatNumberInput) {
      const email = this.vatEmailInput.value.trim();
      const vatNumber = this.vatNumberInput.value.trim();

      if (email && vatNumber) {
        if (!AlpHelpers.isEmailValid(email)) {
          this.showError(this.MESSAGE_TYPES.WRONG_EMAIL);
        } else {
          this.validateVat(email, vatNumber);
        }

        return;
      } else if (email || vatNumber) {
        if (!email) {
          this.showError(this.MESSAGE_TYPES.NO_EMAIL);
        }

        if (email && !AlpHelpers.isEmailValid(email)) {
          this.showError(this.MESSAGE_TYPES.WRONG_EMAIL);
          return;
        }

        if (!vatNumber) {
          this.showError(this.MESSAGE_TYPES.NO_VAT);
        }

        return;
      }

      this.gotoCheckout(true);
    }
  }

  onInputChange(evt) {
    if (evt.target) {
      if (evt.target.getAttribute('id') === 'vat-email') {
        if (this.formEl) {
          const email = evt.target.value.trim();
          const varName = encodeURIComponent('checkout[email]');
          const field = email ? `${varName}=${ encodeURIComponent(email)}` : '';
          const query = field ? `?${field}` : '';

          this.formEl.setAttribute('action', `${this.formActionUrl}${query}`);
        }
      }
    }
  }

  init() {
    const { formName, formAction  } = this.dataset;
    this.validateButtonEl = this.querySelector('button.vat-button');
    this.vatEmailInput = this.querySelector('#vat-email');
    this.vatNumberInput = this.querySelector('#vat-number');
    this.erroContainerEl = this.querySelector('.error-container');
    this.formEl = document.querySelector(`form[id="${formName}"]`);
    this.formActionUrl = formAction;

    this.validateButtonEl && this.validateButtonEl.addEventListener('click', this.validateVATForm.bind(this));
    this.vatEmailInput && this.vatEmailInput.addEventListener('input', this.onInputChange.bind(this));
    // this.vatNumberInput && this.vatNumberInput.addEventListener('input', this.onInputChange.bind(this));
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 100);
  }
}


customElements.define('alp-vat-validation', AlpVatValidation);
customElements.define('input-show-hide-pwd', InputShowHidePwd);
customElements.define('language-selector', LanguageSelector);
